import React from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';
import moment from 'moment';
import { Input } from '../../../../../../../CommonComponents/OPL/Input/Input';
import { Tooltip } from '../../../../../../../CommonComponents/OPL/Tooltip/Tooltip';
import { TRUNCATE_FILE_NAME_THRESHOLD } from '../../AutoAccountsAgreements.meta';
import { Button } from '../../../../../../../CommonComponents/OPL/Button/Button';
import { truncateFileName } from '../../../../../../../CommonUtils/truncateFileName';
import { Toggle } from '../../../../../../../CommonComponents/OPL/Toggle/Toggle';
import { AgreementDTO } from '../../../../api/useFirmSettingsQuery';

interface Props {
  index: number;
  defaultValue: {
    name?: string;
    isActive?: boolean;
  };
  formBag: UseFormReturn<any>;
  hideInactiveAgreements?: boolean;
  agreement: AgreementDTO;
  onDownloadAgreement(id: string, name: string): void;
}

export const AgreementRow: React.FC<Props> = ({
  index,
  defaultValue,
  agreement,
  hideInactiveAgreements,
  formBag,
  onDownloadAgreement,
}) => {
  const { name: watchedName, isActive: watchedIsActive } = useWatch({
    control: formBag.control,
    name: `agreements[${index}]`,
    defaultValue,
  });

  const {
    formState: { errors },
  } = formBag;

  return (
    <tr
      // TODO: DO WE STILL NEED THIS?
      // TODO: This is an hack needed because in react-hook-form v6 the shouldUnregister = false
      // flag doesn't ensure array fields are not unregistered.
      // see: https://codesandbox.io/s/jovial-ramanujan-5rrt6 and try changing between v6 and v7
      style={{
        visibility: hideInactiveAgreements && !watchedIsActive ? 'collapse' : 'visible',
        opacity: hideInactiveAgreements && !watchedIsActive ? 0 : 1,
      }}
    >
      <td>
        <Input
          {...formBag.register(`agreements[${index}].name`)}
          defaultValue={defaultValue.name}
          aria-label="Agreement name"
          type="text"
          formVariant={errors?.agreements?.[index]?.name ? 'error' : undefined}
          helperText={errors?.agreements?.[index]?.name?.message}
        />
      </td>

      <td>
        <Tooltip
          content={agreement.file}
          disabled={agreement.file.length <= TRUNCATE_FILE_NAME_THRESHOLD}
          placement="top"
          isOverflowWrap
        >
          <Button
            variant="link"
            onClick={() => onDownloadAgreement(agreement.id, watchedName || agreement.file)}
          >
            {truncateFileName(agreement.file, TRUNCATE_FILE_NAME_THRESHOLD)}
          </Button>
        </Tooltip>
      </td>

      <td>
        <Toggle
          {...formBag.register(`agreements[${index}].isActive`)}
          defaultChecked={defaultValue.isActive}
          size="small"
          aria-label="Toggle agreement active state"
        />
      </td>

      <td css="white-space: nowrap">{moment(agreement.lastUpdated).format('MMMM DD, YYYY')}</td>

      <td css="white-space: nowrap">{agreement.fileSize}</td>
    </tr>
  );
};
